import * as React from "react";
import LoginModal, {LoginModalContent, LoginModalHeader} from "./LoginModal";
import QuestionAnswerToggler from "./QuestionAnswerToggler";
import ForgotPassword from "./ForgotPassword";

interface Props {
}

enum UserType {
    SVV ,
    Fylkeskommune,
    Kommune,
    Datafangst
}

export default class LoginHelp extends React.Component<Props, {}>{
    constructor(props: Readonly<Props>) {
        super(props);
    }
    render(){

        return(
            <>
                <LoginModal>
                   <LoginModalHeader title={"Datafangst"} />
                   <a className={"df-backlink"} href={"/"}>
                       <i className={"fa fa-arrow-left"}/>
                       <span>Tilbake til innlogging</span>
                   </a>
                   <LoginModalContent>
                        <h2>Hva gjelder problemet?</h2>
                       <QuestionAnswerToggler title={"Jeg har glemt passordet mitt"}>
                           <ForgotPassword/>
                       </QuestionAnswerToggler>
                       <QuestionAnswerToggler title={"Jeg trenger tilgang til en kontrakt"}>
                           Du må kontakte eieren av kontrakten du skulle hatt tilgang til.
                           Kontrakteieren kan legge til din bruker på kontrakten.
                       </QuestionAnswerToggler>
                       <QuestionAnswerToggler title={"Jeg fikk en e-post med bekreftelseslenke, men den har utløpt"}>
                           Få en fornyet lenke tilsendt ved å <a href={"/noauth/#!/user/resetpassword"}>sette nytt passord</a>.
                       </QuestionAnswerToggler>
                       <QuestionAnswerToggler title={"Annet problem/feil"}>
                           Ved andre spørsmål eller feil,
                           ta kontakt med <a href={"mailto:datafangst-support@vegvesen.no"}>Datafangst support</a>
                       </QuestionAnswerToggler>
                   </LoginModalContent>
                </LoginModal>

            </>
        )
    }
}
